import { createRouter, createWebHashHistory } from 'vue-router';
import Dashboard from './home/Dashboard.vue';
/* eslint-disable */
/* jscs:disable */

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            name: 'dashboard',
            component: Dashboard
        }
    ]});

export default router;